import Vuex from 'vuex'
import Vue from 'vue'
import contextualHelp from './modules/contextualHelp'
import interactivePlotCPConf from './modules/interactivePlotCP'
import interactivePlotAofConf from './modules/interactivePlotAoF'
import interactivePlotADConf from './modules/interactivePlotAD'
import interactivePlotCVConf from './modules/interactivePlotCV'
import reportViewer from './modules/reportViewer'
import navigationSection from './modules/navigationSection'
import configurationWindow from './modules/configurationWindow'
import terminalSection from './modules/terminalSection'
import sharingWindow from './modules/sharingWindow'
import mainApp from './modules/mainApp'
import auth from './modules/auth/index.js'
import middleware from './modules/middleware/index.js'
import subscriptionPlans from './modules/subscriptionModule/index.js'
import contactQuery from './modules/contactquery/index.js'
import Constants from './modules/constants/index.js'

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
    modules: {
        contextualHelp,
        interactivePlotCPConf,
        interactivePlotAofConf,
        interactivePlotADConf,
        interactivePlotCVConf,
        reportViewer,
        navigationSection,
        configurationWindow,
        terminalSection,
        sharingWindow,
        mainApp,
        auth,
        middleware,
        subscription:subscriptionPlans,
        contactquery:contactQuery,
        constants:Constants
    }
})